import { __extends } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import OfferService from '@/modules/offers/OfferService';
var offer = {
  name: '',
  qr: '',
  code: '',
  price: 0,
  start_date: '',
  end_date: '',
  discount_type: 'percent',
  description: ''
};

var OfferModel =
/** @class */
function (_super) {
  __extends(OfferModel, _super);

  function OfferModel() {
    var _this = _super.call(this, offer, OfferService) || this;

    _this.modelName = 'Oferta';
    _this.request = 'JSON';
    return _this;
  }

  return OfferModel;
}(BaseModel);

export default OfferModel;